import { render, staticRenderFns } from "./UnidadeMedidaCadastro.vue?vue&type=template&id=46452622&scoped=true&lang=html&"
import script from "./UnidadeMedidaCadastro.vue?vue&type=script&lang=js&"
export * from "./UnidadeMedidaCadastro.vue?vue&type=script&lang=js&"
import style0 from "./UnidadeMedidaCadastro.vue?vue&type=style&index=0&id=46452622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46452622",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
